import { Component, Input, OnInit } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-registration-flow',
  templateUrl: './registration-flow.component.html',
  styleUrls: ['./registration-flow.component.css']
})
export class RegistrationFlowComponent implements OnInit {
  @Input() message: any;
  @Input() inputValue: string;
  @Input() intentName: string;
  isInvalid: boolean = false; // Tracks invalid input
  startWithFiveIsInvalid: boolean = false; // Tracks invalid input
  nineDigitValidIsInvalid: boolean = false; // Tracks invalid input

  constructor(public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
  }

  ngOnChanges(): void {
    this.validateInput();
  }

  validateInput(): void {
    let value = this.inputValue.toString();

    if (!value) {
      this.isInvalid = false;
      this.startWithFiveIsInvalid = false;
      this.nineDigitValidIsInvalid = false;
      return;
    }

    if (value.includes("+")) {
      value = value.slice(4); // Remove first 3 characters
      if (!value) {
        this.isInvalid = false;
        this.nineDigitValidIsInvalid = true;
        this.startWithFiveIsInvalid = true;
        return;
      }
    }

    if (value[0] !== '5' || value.length > 9 || !this.isNumeric(value)) {
      // Validate: Must start with 5, be exactly 9 digits, and contain only numbers
      if(value[0] !== '5'){
        this.startWithFiveIsInvalid = true;
      }else{
        this.startWithFiveIsInvalid = false;
      }

      if ((value.includes('+') && value.length != 13) || (!value.includes('+') && value.length != 9) || !this.isNumeric(value)) {
        this.nineDigitValidIsInvalid = true;
      } else {
        this.nineDigitValidIsInvalid = false;
      }

      this.isInvalid = true;
      return;
    }else{
      if ((value.includes('+') && value.length != 13) || (!value.includes('+') && value.length != 9) || !this.isNumeric(value)) {
        this.nineDigitValidIsInvalid = true;
      } else {
        this.nineDigitValidIsInvalid = false;
      }
      this.isInvalid = false;
      this.startWithFiveIsInvalid = false;
      return;
    }
  }

  getInputForm(ele:string) {
    console.log('this.intentName !== ', this.intentName)
    if (this.intentName !== 'greet2') {
      return '5xx xxx xxx';
    }
    let value = this.inputValue.toString();

    if (!value) {
        return '5xx xxx xxx';
    }
    if (value.includes("+")) {
      value = value.slice(4); // Remove first 3 characters
      if (!value) {
        return '5xx xxx xxx';
      }
    }
    const padded = (value + 'x'.repeat(9)).slice(0, 9);
    return `${padded.slice(0, 3)} ${padded.slice(3, 6)} ${padded.slice(6)}`;
}

isNumeric(value: string): boolean {
  return /^\d+$/.test(value); // Matches only digits (0-9)
}

  
  
}
